import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConfigurationService } from '../store/configuration.service';
import { LssConfigurationEntity } from '../store/configuration.datamodel';
import { PermissionsService } from '../../user/permissions/permissions.service';
import { LSSEntityObject } from '../../shared/list/lssEntity.datamodel';
import { AppComponentsType } from '../../publish/component/store/component.datamodel';
import { ActivationParametersService } from '../../activation-parameters/activation-parameters.service';

@Component({
    selector: 'ama-ng-app-store-configuration',
    templateUrl: './configuration.component.html',
    styleUrls: ['./configuration.component.scss'],
    standalone: false
})
export class ConfigurationComponent implements OnInit, OnDestroy {
  @Input() entitySelected!: LSSEntityObject;
  @Input() appComponentsType!: AppComponentsType;

  selectedEntity: LssConfigurationEntity | undefined;
  officesInSelectedEntity = 0;
  areSomeOrAllEntitiesSelected = false;
  canCreateConfiguration = false;
  areConfigurationOverridesEnabled = false;
  readonly subscriptions = new Subscription();

  constructor(
    protected readonly configurationService: ConfigurationService,
    private readonly permissionsService: PermissionsService,
    private readonly activationParametersService: ActivationParametersService
  ) {
  }

  ngOnInit(): void {
    const isFarmMap = this.appComponentsType === AppComponentsType.SECO_FARM_MAP;
    const isScriptApp = this.appComponentsType === AppComponentsType.SMART_SCRIPT;
    const isScriptOverrideEnabled = isScriptApp && this.activationParametersService.isActive('MYA_SCRIPT_CONFIG_OVERRIDE_A');
    this.areConfigurationOverridesEnabled = isFarmMap || isScriptOverrideEnabled;
    this.canCreateConfiguration = this.permissionsService.isAllowedToCreateConfiguration(this.entitySelected?.label ?? '');
    this.subscriptions.add(
      this.configurationService.officesInActiveParent$.subscribe(offices => {
        this.officesInSelectedEntity = offices.length;
      }),
    );
    this.subscriptions.add(
      this.configurationService.activeParent$.subscribe(entity => {
        this.selectedEntity = entity;
      }),
    );
    this.subscriptions.add(
      this.configurationService.areSomeOrAllEntitiesSelected$.subscribe(areSomeOrAllOfficesSelected => {
        this.areSomeOrAllEntitiesSelected = areSomeOrAllOfficesSelected;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
